import React, { useEffect, useRef, useLayoutEffect } from 'react';
import { usePlayer } from '../../contexts/PlayerContext';

export default function InlineVideoAnchor({ videoId, style, playOnLoad }) {
  const { attachAnchor, detachAnchor, load, isActive, videoId: currentVideoId } = usePlayer();
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    attachAnchor(el);
    return () => detachAnchor(el);
  }, [attachAnchor, detachAnchor]);

  useEffect(() => {
    if (videoId) {
      // Always load the video, even if player is already active
      // Pass play intent when provided (user clicked into this video)
      load(videoId, { play: !!playOnLoad });
    }
  }, [videoId, playOnLoad, load]);

  return (
    <div
      ref={ref}
      style={{
        position: 'relative',
        width: '100%',
        background: '#000',
        // 16:9 container without display:none to keep iOS happy
        paddingTop: '56.25%',
        borderRadius: 8,
        overflow: 'hidden',
        ...style,
      }}
      aria-label="Inline Video Anchor"
    />
  );
}
